module.exports = "https://static.wanderu.com/static/media/bus.f75fdacf.svg";